
import React from 'react';

type PersonRoleSelectorProps = {
  name: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  options: string[];
  required?: boolean;
  error?: string;
}

export const PersonRoleSelector: React.FC<PersonRoleSelectorProps> = ({ name, value, onChange, options, required, error }) => (
  <>
    <select
      name={name}
      value={value}
      onChange={onChange}
      required={required}
      aria-invalid={!!error}
      aria-describedby={error ? `${name}-error` : undefined}
      className="form-control">
        <option value="" disabled>
          Seleccione un rol
        </option>
        {options.map(opt => (
          <option key={opt} value={opt}>
            {opt}
          </option>
        ))}
    </select>
    
    {error && (
      <div id={`${name}-error`} className="invalid-feedback">
        {error}
      </div>
    )}

  </>
);
